export default function formatCnpj(cnpj: string): string {
  if (!cnpj) {
    return "";
  }

  if (cnpj.length !== 14) {
    return cnpj;
  }

  return cnpj.replace(/[^\d]+/g, "").replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}
